export const docuSignGetAuthUrlQuery = `
  mutation DocuSignGetAuthUrl($companyId: Int!) {
    result: docuSignGetAuthUrl(companyId: $companyId) {
      authUrl
    }
  }
`;

export const docuSignProcessAuthCodeQuery = `
  mutation DocuSignProcessAuthCode($input: DocuSignAuthCodeInput!) {
    sent: docuSignProcessAuthCode(input: $input) {
      success
      message
    }
  }
`;

export const docuSignCreateTemplateViewQuery = `
  mutation DocuSignCreateTemplateView(
    $companyId: Int!,
    $templateId: String!
  ) {
    result: docuSignCreateTemplateView(companyId: $companyId, templateId: $templateId) {
      templateUrl
    }
  }
`;

export const docuSignListTemplatesQuery = `
  query DocuSignListTemplates($companyId: Int!) {
    items: docuSignListTemplates(companyId: $companyId) {
      templateId
      name
    }
  }
`;
